module.exports = __webpack_public_path__ + "static/media/addition-period-icon.332345fb.svg";